<freud-dialog
	[visible]="isOpen"
	[modal]="true"
	[header]="'MENU.TOGGLE' | translate"
>
	<div>
		<span class="modal__description zk-inline-block zk-mb-3">{{
			'MENU.TOGGLE_MODAL_DESCRIPTION' | translate
		}}</span>
		<ul class="zk-mx-5 zk-mb-3">
			<li class="modal__topic">
				{{ 'MENU.TOGGLE_MODAL_TOPIC_1' | translate }}
			</li>
			<li class="modal__topic">
				{{ 'MENU.TOGGLE_MODAL_TOPIC_2' | translate }}
			</li>
			<li class="modal__topic">
				{{ 'MENU.TOGGLE_MODAL_TOPIC_3' | translate }}
			</li>
		</ul>
		<div>
			<freud-checkbox
				[(ngModel)]="preventShow"
				[label]="'MENU.TOGGLE_MODAL_CHECKBOX' | translate"
			></freud-checkbox>
		</div>
	</div>
	<div freudTemplatefooter class="zk-flex zk-flex-end zk-gap-2">
		<freud-button (click)="onCancel.emit()" color="secondary">{{
			'MENU.CANCEL' | translate
		}}</freud-button>
		<freud-button (click)="toggleStatus()">{{
			'MENU.TOGGLE_ONLINE' | translate
		}}</freud-button>
	</div>
</freud-dialog>
